import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/core/services/config-service';
import { NotificationListResponse } from '../../models/notification.model';

@Injectable()
export class NotificationService {
  constructor(private http: HttpClient) {}
  configService = inject(ConfigService);

  getNotifications(params: { page: number; pageSize: number }): Observable<NotificationListResponse> {
    const url = this.configService.readConfig().baseUrlBusiness +
      `/notifications?PageSize=${params.pageSize}&PageNumber=${params.page}`;
    return this.http.get<NotificationListResponse>(url);
  }

  getUnreadCount(): Observable<number> {
    const url = this.configService.readConfig().baseUrlBusiness + '/notifications/unread-count';
    return this.http.get<number>(url);
  }

  markAsRead(notificationId: number): Observable<void> {
    const url = this.configService.readConfig().baseUrlBusiness + `/notifications/${notificationId}/read`;
    return this.http.put<void>(url, {});
  }

  markAllAsRead(): Observable<void> {
    const url = this.configService.readConfig().baseUrlBusiness + '/notifications/read-all';
    return this.http.put<void>(url, {});
  }
}
